@if (colDefs != null) {
  <section class="scroll-container left-nav-wrapper">
    <div class="d-flex justify-content-between">
      <h1>Timeclock File Validation</h1>
      <button class="btn btn-tertiary" (click)="navigateToPayrollHub()">
        Return to Payroll Hub
      </button>
    </div>
    <div class="d-flex mb-5">
      <h5 class="me-3">
        First Day of Pay Cycle: {{ header.pdi.PeriodBegin | date: 'MM/dd/yyyy' }}
      </h5>
      <h5 class="me-3">Last Day of Pay Cycle: {{ header.pdi.PeriodEnd | date: 'MM/dd/yyyy' }}</h5>
      <h5>Pay Date: {{ header.pdi.TargetPayDate | date: 'MM/dd/yyyy' }}</h5>
    </div>
    <div class="d-flex justify-content-between">
      @if (header?.file != null) {
        <h4>Please Review Your Timesheet Before Clicking Approve ({{ header.file.FileName }})</h4>
      }
      <div>
        <label for="periodEnd" class="fw-bold">Period End</label>
        <div class="input-group">
          <input
            [(ngModel)]="periodEndDate"
            class="form-control datepicker"
            ngbDatepicker
            id="periodEnd"
            #d="ngbDatepicker"
            [firstDayOfWeek]="7"
            [minDate]="formatDatePickerValue(header.pdi.PeriodBegin)"
            [placement]="['bottom-end', 'top-end']" />
          <img src="assets/icons/calendar.svg" (click)="d.toggle()" class="icon-append" />
        </div>
      </div>
    </div>
    <div style="line-height: 3">
      <div style="line-height: 1">
        <small>
          <strong>{{ rowFilterIndicator }}</strong>
        </small>
      </div>
      <div class="btn-group btn-group-toggle me-4" role="group" aria-label="Payline View Controls">
        <button
          class="btn btn-secondary row-view-btn rounded-start"
          (click)="onRowViewChange('all')">
          All
        </button>
        <button class="btn btn-secondary row-view-btn" (click)="onRowViewChange('warnings')">
          Warnings
        </button>
        <button
          class="btn btn-secondary row-view-btn rounded-end"
          (click)="onRowViewChange('errors')">
          Errors
        </button>
      </div>
    </div>
    <ag-grid-angular
      [ngStyle]="{ height: gridHeight }"
      class="ag-theme-alpine"
      [columnDefs]="colDefs"
      [rowData]="rowData"
      [stopEditingWhenCellsLoseFocus]="true"
      [singleClickEdit]="true"
      [enableBrowserTooltips]="true"
      (gridReady)="onGridReady($event)"
      (cellEditingStopped)="onCellEditingStopped($event)"></ag-grid-angular>
    <hr class="mt-5" />
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary me-2" (click)="goBack.emit()">Back</button>
      <button class="btn btn-secondary me-2" (click)="runPayroll(false)">
        Discard Timesheet & Continue
      </button>
      <button class="btn btn-primary" (click)="approveFile()" [disabled]="!edited && errors">
        Approve
      </button>
    </div>
  </section>
}
